import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/mina-sidor/offertforfragningar")({
  beforeLoad: () => {
    throw redirect({ to: "/mina-sidor/forfragningar", statusCode: 301 });
  },
});
